import React, {useEffect, useState} from 'react';
import * as _ from 'lodash';
import {getJsonQueryString, removeCookie, serverLog} from '../common/utils';
import ErrorPage from '../components/error/ErrorPage';
import {CIG_SSO} from '../common/constants';

const getErrorMessage = (auth) => {
    const error = {
        category: 'ERROR',
        logMessage: 'CigB2cLogin: getErrorMessage -Fail to get login ID: ' + window.location.search
    };
    serverLog(auth, error);

    return (
        <div id="tenant-nav-error-container">
            Login Id not found.
        </div>
    );
};
getErrorMessage.displayName = 'getErrorMessage';

const isSystemClockOutOfSync = () => {
    const currentTime = Date.now() / 1000;
    const serverTimeUTC = _.get(window.CIG, 'serverTimeUTC', 0);
    if (serverTimeUTC > 0) {
        if (Math.abs(serverTimeUTC - currentTime) > 179) {
            // 3 minutes in future time and pass time
            const msg = (serverTimeUTC - currentTime) >= 179 ? '(in the past)' : '(in the future)';
            // eslint-disable-next-line no-console
            console.log('isSystemClockOutOfSync - System clock is not sync with NTP server. currentTime ' + msg + ': ' + currentTime + ', server time: ' + serverTimeUTC);
            removeCookie(CIG_SSO.cookieJWT);
            removeCookie(CIG_SSO.contextCookie);
            return true
        }
    }
    else if (serverTimeUTC === 0) {
        // eslint-disable-next-line no-console
        console.log('Failed to get server UTC time.');
    }
    return false;
}

export function CigAuthLogin({auth}) {
    const [error, setError] = useState('');

    useEffect(() => {
        if (!isSystemClockOutOfSync()) {
            const queryStr = getJsonQueryString();
            let id = _.get(queryStr, '_id', '');
            if (!_.isEmpty(id)) {
                window.open(window.location.origin + '/ui/tenant/login/' + id, '_self');
            }
            else {
                setError('loginIdErr');
            }
        }
        else {
            setError('clockOutOfSync');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isSystemClockOutOfSync]);

    return (
        <div>
            {
                (error === 'clockOutOfSync') && (
                    <ErrorPage id="system-clock-unsync-error" title={'We encountered an error while accessing your Data Infrastructure Insights.'}
                        message={`System time and date are incorrect. Please adjust your system time settings.`}
                        showCIContact={false} showLogout={false} support={true} auth={window.auth}
                        data-testid="system-clock-unsync-error"
                    />
                )
            }
            {
                (error === 'loginIdErr') && (
                    <ErrorPage id="login-error" title="We encountered a problem accessing your request.">
                        {getErrorMessage(auth)}
                    </ErrorPage>
                )
            }
        </div>
    );
}

CigAuthLogin.displayName = 'CigAuthLogin';
export default CigAuthLogin;
